import useLanguage from "../../hooks/useLanguage";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserLanguage } from "../../features/user/userSlice";

const HambMenu = ({ showMenu, setShowMenu, inLandingPage = true }) => {
  const navigate = useNavigate();
  const currentLanguage = useSelector(selectUserLanguage) || "es";

  // Get texts based on current language
  const texts = useLanguage(currentLanguage, "views.landingPage");

  const handleNavigation = (path) => {
    navigate(path);
  };

  const scrollToSection = (id) => {
    if (!inLandingPage) {
      handleNavigation("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        section?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      const section = document.getElementById(id);
      section?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="menu-options">
      <span
        onClick={() => {
          setShowMenu(false);
          setTimeout(() => scrollToSection("beneficios"), 0);
        }}
      >
        {texts.header.beneficios}
      </span>
      <span
        onClick={() => {
          setShowMenu(false);
          setTimeout(() => scrollToSection("incentivos"), 0);
        }}
      >
        {texts.header.incentivos}
      </span>
      <span
        onClick={() => {
          setShowMenu(false);
          setTimeout(() => scrollToSection("planes"), 0);
        }}
      >
        {texts.header.planes}
      </span>
      <span
        onClick={() => {
          setShowMenu(false);
          setTimeout(() => scrollToSection("aplicaion"), 0);
        }}
      >
        {texts.header.aplicacion}
      </span>
      <span onClick={() => handleNavigation("/roadmap")}>
        {texts.header.roadmap}
      </span>
      <span onClick={() => handleNavigation("/blog")}>Blog</span>
      <span onClick={() => handleNavigation("/contact")}>
        {texts.header.contact}
      </span>
    </div>
  );
};

export default HambMenu;
